import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {userSearchResultStateSelector} from './user-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {UserSearchCriteria} from 'src/openapi/admin/models/UserSearchCriteria';
import type {UserSearchFiltering} from 'src/openapi/admin/models/UserSearchFiltering';
import type {UserSortField} from 'src/openapi/admin/models/UserSortField';

export const userSearchResultAccountsSlice = getCachedTableDataSlice<
    Record<string, string>,
    UserSearchCriteria,
    UserSortField,
    UserSearchFiltering
>('userSearchResultAccounts');

export const userSearchResultAccountsActions = userSearchResultAccountsSlice.actions;

const userSearchResultAccountsCacheSelector: CachedTableCacheSelector<Record<string, string>>
    = state => state.userSearchResult.accounts.cache;
export const userSearchResultAccountsDataSelector: CachedTableDataSelector<Record<string, string>>
    = state => state.userSearchResult.accounts;
export const userSearchResultAccountsResultSelector = getCachedTableResultSelector(
    userSearchResultAccountsCacheSelector,
    userSearchResultStateSelector,
);
